<template>
  <!--列表-->
  <el-dialog
    class="chartDia"
    :visible="true"
    width="90%"
    :show-close="false"
    @close="close"
  >
    <div slot="title" class="slotTit">支付</div>
    <div class="colorBlock">订单</div>
    <div class="totalMoney">
      <label>订单数：</label>
      <span>{{ finalObj.count }}笔</span>
      <label>打款金额合计：</label>
      <span>{{ finalObj.price | moneyFixed }}</span>
      <label>账户余额：</label>
      <span>{{ tableResp.balance | moneyFixed }}</span>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      :stripe="true"
      :highlight-current-row="false"
      ref="openList"
      :default-expand-all="itemData.data.id > 0"
      header-row-class-name="noBorder"
    >
      <el-table-column label="选择" align="center" width="50">
        <template slot-scope="{ row }">
          <el-checkbox
            v-model="row.allFlag"
            @change="changeAll(row)"
            :disabled="![1, 3, 4].includes(row.payStatus)"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="序号"
        type="index"
      />
      <el-table-column type="expand" prop="id">
        <template slot-scope="{ row }">
          <div class="expandBox">
            <el-checkbox
              v-model="row.payFlag"
              @change="changePay(row)"
              :disabled="![1, 3, 4].includes(row.payStatus)"
            ></el-checkbox>
            <p>项目订单</p>
            <div class="orderNo">
              <p>订单编号：</p>
              <p>{{ row.orderNo }}</p>
            </div>
            <div class="orderNo">
              <p>项目金额：</p>
              <div style="display:flex;align-items:center;">
                <span style="margin-right:10px;">
                  {{
                    (row.orderPrice - row.platformServicesPrice) | moneyFixed
                  }}
                </span>
                <el-button
                  primary
                  type="text"
                  style="padding:0;"
                  @click="showComponent('payDetail', row)"
                >
                  详情
                </el-button>
                <el-popover
                  placement="top-start"
                  trigger="hover"
                  v-if="
                    searchQuery.projectStructureType == 1 && row.discountPrice
                  "
                >
                  <div>
                    应付：{{
                      (row.initOrderPrice - row.platformServicesPrice)
                        | moneyFixed
                    }}
                  </div>
                  <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
                  <div>
                    实付：{{
                      (row.orderPrice - row.platformServicesPrice) | moneyFixed
                    }}
                  </div>
                  <img
                    src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                    slot="reference"
                    class="info"
                  />
                </el-popover>
              </div>
            </div>
            <div>
              <p>支付状态：</p>
              <p>{{ row.csoPayStatus | transCsoStatus }}</p>
            </div>
            <div>
              <p>支付时间：</p>
              <p>{{ row.orderPayDt | transDate }}</p>
            </div>
          </div>
          <div class="expandBox">
            <el-checkbox
              v-model="row.serviceFlag"
              @change="changeService(row)"
              :disabled="judgeService(row)"
            ></el-checkbox>
            <p>平台服务费订单</p>
            <div class="orderNo">
              <p>订单编号：</p>
              <p>{{ row.serviceOrderNo }}</p>
            </div>
            <div class="orderNo">
              <p>平台服务费：</p>
              <div style="display:flex;align-items:center;">
                <span style="margin-right:10px;">
                  {{ row.platformServicesPrice | moneyFixed }}
                </span>
                <el-button
                  primary
                  type="text"
                  style="padding:0;"
                  @click="showComponent('serviceDetail', row)"
                >
                  详情
                </el-button>
              </div>
            </div>
            <div>
              <p>支付状态：</p>
              <p>{{ row.servicesPricePayStatus | serviceStatus }}</p>
            </div>
            <div>
              <p>支付时间：</p>
              <p>{{ row.servicePayDt | transDate }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="orderNo" label="订单编号"></el-table-column> -->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="projectName"
        label="项目名称"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="taskDt"
        label="任务月度"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="taskDt"
        label="订单生成时间"
        v-if="searchQuery.projectStructureType == 1"
        key="taskDt"
      >
        <template slot-scope="{ row }">{{ row.createDt | transDate }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="taskDt"
        label="支付截止时间"
        v-if="searchQuery.projectStructureType == 1"
        key="orderEndPayDt"
      >
        <template slot-scope="{ row }">
          {{ row.orderEndPayDt | transAllTime }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="本次需打款总金额"
        width="120"
      >
        <template slot-scope="{ row }">
          <div
            style="display:flex;justify-content:space-around;align-items:center;"
          >
            <!-- <span>{{ row.orderPrice | moneyFixed }}</span> -->
            <!-- 只有服务费 -->
            <span v-if="!row.payFlag && row.serviceFlag">
              {{ row.platformServicesPrice | moneyFixed }}
            </span>
            <span v-else>{{ row.currPayPrice | moneyFixed }}</span>
            <el-popover
              placement="top-start"
              trigger="hover"
              v-if="searchQuery.projectStructureType == 1 && row.discountPrice"
            >
              <div>应付：{{ row.initOrderPrice | moneyFixed }}</div>
              <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
              <div>实付：{{ row.orderPrice | moneyFixed }}</div>
              <img
                src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                slot="reference"
                class="info"
              />
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payStatus"
        label="支付状态"
      >
        <template slot-scope="{ row }">
          <span>{{ row.payStatus | payStatusFil }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginationData.pageNo"
      :total="totalElements"
      :page-size="paginationData.pageSize"
      layout="total, prev, pager, next, jumper"
      style="padding:15px"
    ></el-pagination>
    <div v-if="finalObj.price > tableResp.balance" class="hint">
      当前所选订单总金额超过余额金额，请重新选择
    </div>
    <div
      style="margin:20px auto;display:flex;justify-content:space-around;width:30%;"
    >
      <el-button type="primary" plain @click="close">返回</el-button>
      <el-button
        type="primary"
        @click="next"
        :disabled="finalObj.price <= 0 || finalObj.price > tableResp.balance"
      >
        下一步
      </el-button>
    </div>
    <component
      :is="componentName"
      v-if="componentName"
      :show-dialog="showDetail"
      :type="type"
      @close="closeEvent"
    ></component>
  </el-dialog>
</template>

<script>
import payDetail from './fenqiPayDetail.vue';
import serviceDetail from './fenqiServiceDetail.vue';
import confirmPay from './confirmPay.vue';
import sanjiConfirmPay from './sanjiConfirmPay.vue';
import getiDetail from './getiDetail.vue';
import gerenDetail from './gerenDetail.vue';
import { merge } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect';
import { projectOrderPayStatus } from '@/config/staticData';
import sanji from '@/Mixin/sanji';
export default {
  mixins: [pageInation, makeSure, sanji],
  inject: ['itemData'],
  data() {
    return {
      selectedList: [],
      selectedObj: {},
      curMoney: '',
      noNeedForDate: this.$route.taskDt ? true : false,
      projectOrderPayStatus,
      ruleForm: {
        taskDate: ''
      }, // 用户信息
      getList: merge.mergeProjectOrder, // 获取列表的AJAX
      searchQuery: {
        projectStructureType: '',
        id: this.itemData.data ? this.itemData.data.id : '',
        patternType: this.$parent.searchQuery.patternType
      },
      showDetail: false,
      componentName: '',
      type: '',
      // 下发当前选中的item
      item: {
        data: null
      },
      childNotSetPageNumStoreFlag: false
    };
  },
  components: {
    dicSelect,
    payDetail,
    serviceDetail,
    confirmPay,
    getiDetail,
    gerenDetail,
    sanjiConfirmPay
  },
  computed: {
    finalObj() {
      let count = 0,
        price = 0;
      let arr = Object.keys(this.selectedObj);
      for (let item of arr) {
        count += this.selectedObj[item].count;
        price += this.selectedObj[item].price;
      }
      return { count, price };
    }
  },
  provide() {
    return {
      itemData: this.item
    };
  },
  methods: {
    fenqiPageChange() {
      let arr = Object.keys(this.selectedObj);
      arr.filter(item => {
        //已选择列表
        let item2 = this.selectedObj[item];
        this.tableData.filter(items => {
          if (item2.id == items.id) {
            if (item2.count === 2) {
              items.allFlag = true;
              items.payFlag = true;
              items.serviceFlag = true;
            } else if (item2.type === 3) {
              //只有订单没服务费
              items.payFlag = true;
              items.serviceFlag = [2].includes(items.servicesPricePayStatus)
                ? true
                : false;
              if ([1, 2].includes(items.servicesPricePayStatus)) {
                items.allFlag = true;
              } else {
                items.allFlag = false;
              }
            } else if (item2.type === 2) {
              items.allFlag = false;
              items.payFlag = false;
              items.serviceFlag = true;
            }
          }
        });
      });
    },
    closeEvent() {
      this.componentName = '';
    },
    judgeService(row) {
      if (![0, 3].includes(row.servicesPricePayStatus)) {
        //如果服务费订单不是可支付的状态 禁用按钮
        return true;
      } else if (row.payFlag && row.serviceFlag) {
        //如果订单状态被选中并且服务费也被选中 则禁用按钮不可取消
        return true;
      }
    },
    saveData(row) {
      if (row.payFlag && row.serviceFlag) {
        //全都选中状态
        // this.$set(this.selectedObj, row.id, { id: row.id, count: 2, serviceOrderId: row.serviceOrderId, price: row.orderPrice })
        this.$set(this.selectedObj, row.id, {
          id: row.id,
          count: 2,
          serviceOrderId: row.serviceOrderId,
          price: row.currPayPrice
        });
      } else if (row.payFlag && !row.serviceFlag) {
        //只有订单没有服务费
        // this.$set(this.selectedObj, row.id, { id: row.id, count: 1, type: 3, serviceOrderId: row.serviceOrderId, price: row.projectPrice })
        this.$set(this.selectedObj, row.id, {
          id: row.id,
          count: 1,
          type: 3,
          serviceOrderId: row.serviceOrderId,
          price: row.currPayPrice
        });
      } else if (!row.payFlag && row.serviceFlag) {
        //只有服务费没有订单
        this.$set(this.selectedObj, row.id, {
          id: row.id,
          count: 1,
          type: 2,
          serviceOrderId: row.serviceOrderId,
          price: row.platformServicesPrice
        });
      } else {
        //什么都没有
        this.$delete(this.selectedObj, row.id);
      }
    },
    changeAll(row) {
      //改变全选按钮
      // let judge = row.payFlag && row.serviceFlag;
      if (!row.allFlag) {
        //取消全部选中
        row.payFlag = false;
        row.serviceFlag = false;
      } else {
        //全部选中
        row.payFlag = true;
        if ([0, 3].includes(row.servicesPricePayStatus)) {
          row.serviceFlag = true;
        } else {
          row.serviceFlag = false;
        }
      }
      this.saveData(row);
    },
    changePay(row) {
      //改变项目订单
      if (
        row.payFlag &&
        !row.serviceFlag &&
        [0, 3].includes(row.servicesPricePayStatus)
      ) {
        //如果服务费订单未选中并且未支付则一并选中
        row.serviceFlag = true;
      }
      let judge = row.payFlag && row.serviceFlag;
      row.allFlag = judge ? true : false;
      this.saveData(row);
    },
    changeService(row) {
      //改变服务费订单
      let judge = row.payFlag && row.serviceFlag;
      row.allFlag = judge ? true : false;
      this.saveData(row);
    },
    next() {
      //下一步
      let returnArr = [];
      let arr = Object.keys(this.selectedObj);
      for (let item of arr) {
        if (
          this.selectedObj[item].count == 1 &&
          this.selectedObj[item].type == 2
        ) {
          returnArr.push(`_${this.selectedObj[item].serviceOrderId}`);
        } else {
          returnArr.push(this.selectedObj[item].id);
        }
      }
      this.$parent.item.payList = returnArr;
      this.$parent.componentName = 'confirmFenqiPay';
    },
    close() {
      this.$parent.componentName = '';
    },
    showComponent(componentName, item = null) {
      item.projectStructureType = this.searchQuery.projectStructureType;
      this.item.data = item;
      if (componentName == 'payDetail') {
        if (this.searchQuery.projectStructureType == 1) {
          //四级
          this.componentName = 'payDetail';
        } else if (this.searchQuery.projectStructureType == 2) {
          //三级个体
          this.componentName = 'getiDetail';
        } else {
          //三级个人
          this.componentName = 'gerenDetail';
        }
      } else if (componentName == 'confirmPay') {
        if (this.searchQuery.projectStructureType > 1) {
          this.componentName = 'sanjiConfirmPay';
        } else {
          this.componentName = 'confirmPay';
        }
      } else {
        //其他
        this.componentName = componentName;
      }
      localStorage.setItem('activeTask', JSON.stringify(item));
      item ? (this.type = item.type) : '';
      this.showDetail = true;
    }
  },
  created() {
    // let name = this.$route.name;
    this.searchQuery.projectStructureType = this.$parent.searchQuery.projectStructureType;
  },
  watch: {},
  filters: {
    payStatusFil(v) {
      let s = {
        1: '待支付',
        2: '支付中',
        3: '支付失败',
        4: '部分支付成功',
        5: '支付中',
        6: '支付失败'
      };
      return s[v];
    },
    serviceStatus(v) {
      let s = {
        0: '待支付',
        1: '支付中',
        2: '支付成功',
        3: '支付失败'
      };
      return s[v];
    }
  }
};
</script>
<style lang="scss" scoped>
.hint {
  text-align: center;
  color: #f80606;
}
.info {
  width: 14px;
  height: 14px;
  margin-top: -4px;
}
.colorBlock {
  font-size: 20px;
  line-height: 24px;
  display: flex;
  color: #2e2e2f;
  margin-bottom: 20px;
}
.colorBlock::before {
  content: '';
  width: 8px;
  height: 24px;
  background: #1989fa;
  margin-right: 5px;
  display: inline-block;
}
.totalMoney {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 15px;
  label {
    font-size: 14px;
    color: #666;
  }
  span {
    font-size: 20px;
    color: #333;
    margin-right: 80px;
  }
  span:last-of-type {
    margin-right: 0;
  }
}
</style>
